import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Divider, Skeleton } from '@mui/material';
import { getPersonalPromotionChannelAffinity } from '../../../../redux/thunks/affinityHubThunk';
import { actions } from '../../../../redux/reducers/affinityHubReducer';
import { BarChart, CustomButtonGroup } from '../../../shared';
import { PREFERENCES, CHART_OPTIONS, } from './constants';

function PersonalPromotionChannelAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { setPersonalPromotionChannelPreference } = actions;
    const { personalPromotionChannel } = useSelector(state => state.affinityHub);
    const { selectedPreference, data, chartSeries, categories, isLoading } = personalPromotionChannel;

    useEffect(() => {
        dispatch(getPersonalPromotionChannelAffinity());
    }, []);

    return (
        <Box className="box-sizing-border-box border-1-gray br-16px">
            <Box className="flex-column gap-4 padding-24px border-bottom-gray">
                <Box>
                    <Typography className="text-md-semi-bold gray-900">
                        Personal Promotion Channel Affinity
                    </Typography>
                </Box>
                <Box>
                    {isLoading ? <Skeleton height={45} /> :<CustomButtonGroup
                        data={PREFERENCES}
                        selected={selectedPreference}
                        handleClick={(option) => dispatch(setPersonalPromotionChannelPreference({preference: option}))}
                    />}
                </Box>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box className="padding-24px height-343px apexchart-horizontal-bar-chart">
                        {isLoading ? <Skeleton height={340} /> :<BarChart
                            chartOptions={
                                {
                                    ...CHART_OPTIONS,
                                    xaxis: {
                                        ...CHART_OPTIONS.xaxis,
                                        categories: categories,
                                    }
                                }
                            }
                            chartSeries={chartSeries}
                        />}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default PersonalPromotionChannelAffinity;
